import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pedido-list',
  templateUrl: './pedido-list.component.html',
  styleUrls: ['./pedido-list.component.css']
})
export class PedidoListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
